<template>
    <div class="analytics-num-diamonds">
        <h2 class="analytics-num-diamonds__heading">Kusursuzluk Elmasları</h2>
        <div class="analytics-num-diamonds__wr-modes">
            <div class="analytics-num-diamonds__mode">
                <div v-if="showPreloader" class="analytics-num-diamonds__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-num-diamonds__mode-icon"></span>
                    <span class="analytics-num-diamonds__mode-value">{{ this.numDiamondsData.phonemicVowel.collected }} / {{ this.numDiamondsData.phonemicVowel.total }}</span>
                    <span class="analytics-num-diamonds__mode-label">ünlü sesbirimler</span>
                </template>
            </div>
            <div class="analytics-num-diamonds__mode">
                <div v-if="showPreloader" class="analytics-num-diamonds__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-num-diamonds__mode-icon"></span>
                    <span class="analytics-num-diamonds__mode-value">{{ this.numDiamondsData.phonemicConsonant.collected }} / {{ this.numDiamondsData.phonemicConsonant.total }}</span>
                    <span class="analytics-num-diamonds__mode-label">ünsüz sesbirimler</span>
                </template>
            </div>
            <div class="analytics-num-diamonds__mode">
                <div v-if="showPreloader" class="analytics-num-diamonds__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-num-diamonds__mode-icon"></span>
                    <span class="analytics-num-diamonds__mode-value">{{ this.numDiamondsData.phoneticVowel.collected }} / {{ this.numDiamondsData.phoneticVowel.total }}</span>
                    <span class="analytics-num-diamonds__mode-label">ünlü değişkeleri</span>
                </template>
            </div>
            <div class="analytics-num-diamonds__mode">
                <div v-if="showPreloader" class="analytics-num-diamonds__preloader"></div>
                <template v-if="!showPreloader">
                    <span class="analytics-num-diamonds__mode-icon"></span>
                    <span class="analytics-num-diamonds__mode-value">{{ this.numDiamondsData.phoneticConsonant.collected }} / {{ this.numDiamondsData.phoneticConsonant.total }}</span>
                    <span class="analytics-num-diamonds__mode-label">ünsüz değişkeleri</span>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                showPreloader: true,
            };
        },

        computed: {
            numDiamondsData(){
                return this.$store.state.response.analyticsPerfection.numDiamondsData;
            },
        },

        mounted(){
            if(this.$store.state.envDev){
                this.showPreloader = true;
                fetch(this.$store.state.jsonServer.analyticsNumDiamonds)
                .then(response => response.json())
                .then(numDiamondsData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'numDiamondsData',
                        data: numDiamondsData
                    });
                    this.showPreloader = false;
                });
            }
            else{
                this.showPreloader = true;
                fetch(this.$store.state.api.analyticsPerfectionNumDiamonds, {
                    method: 'GET',
                    credentials: 'include'
                })
                .then(async response => {
                    if(response.status !== 200){
                        throw await response.json();
                    }
                    return response.json();
                })
                .then(numDiamondsData => {
                    this.$store.commit('setResponse', {
                        categoryLabel: 'analyticsPerfection',
                        dataLabel: 'numDiamondsData',
                        data: numDiamondsData
                    });
                    this.showPreloader = false;
                })
                .catch(err => {
                    this.$foneturkError({
                        text: 'Bir şeyler ters gitti.'
                    });
                    console.error(err);
                });
            }
        }
    };
</script>
<style scoped src="@/css/components/analytics-num-diamonds.css"></style>